<script setup>
import BrandButton from "@/Components/Brand/BrandButton.vue";
import { useModalogStore } from "@/stores/modalog.js";

const { showModalog } = useModalogStore();

function createList() {
    showModalog({
        type: "ModalogCreateListBrand",
        props: {
            listType: "wish",
        },
    });
}
</script>

<template>
    <BrandButton
        icon-rest-class="text-brand-red"
        class="h-[52px] px-8 text-[17px]"
        @click="createList"
    >
        <template #icon>
            <svg
                viewBox="0 0 23 18"
                class="h-[18px] w-[23px] shrink-0"
                fill="currentColor"
                aria-hidden="true"
            >
                <path
                    d="M21.6547 5.14286C21.9955 5.14286 22.281 5.26629 22.5112 5.51315C22.7414 5.76001 22.8569 6.06515 22.8577 6.42858C22.8585 6.79201 22.743 7.09715 22.5112 7.344C22.2794 7.59086 21.9939 7.71429 21.6547 7.71429L15.6395 7.71429C15.2986 7.71429 15.0127 7.59086 14.7817 7.344C14.5507 7.09715 14.4356 6.792 14.4364 6.42858C14.4372 6.06515 14.5527 5.75958 14.7829 5.51186C15.0131 5.26415 15.2986 5.14115 15.6395 5.14286L21.6547 5.14286ZM21.6547 10.2857C21.9955 10.2857 22.281 10.4091 22.5112 10.656C22.7414 10.9029 22.8569 11.208 22.8577 11.5714C22.8585 11.9349 22.743 12.24 22.5112 12.4869C22.2794 12.7337 21.9939 12.8571 21.6547 12.8571L10.8273 12.8571C10.4865 12.8571 10.2005 12.7337 9.96957 12.4869C9.73858 12.24 9.62349 11.9349 9.6243 11.5714C9.6251 11.208 9.74059 10.9024 9.97077 10.6547C10.201 10.407 10.4865 10.284 10.8273 10.2857L21.6547 10.2857ZM21.6547 15.4286C21.9955 15.4286 22.281 15.552 22.5112 15.7989C22.7414 16.0457 22.8569 16.3509 22.8577 16.7143C22.8585 17.0777 22.743 17.3829 22.5112 17.6297C22.2794 17.8766 21.9939 18 21.6547 18L10.8273 18C10.4865 18 10.2005 17.8766 9.96957 17.6297C9.73858 17.3829 9.62349 17.0777 9.6243 16.7143C9.6251 16.3509 9.74059 16.0453 9.97077 15.7976C10.201 15.5499 10.4865 15.4269 10.8273 15.4286L21.6547 15.4286ZM6.87175 0.369008C7.10273 0.615864 7.21822 0.921435 7.21822 1.28572L7.21822 5.14286L10.8273 5.14286C11.1682 5.14286 11.4537 5.26629 11.6839 5.51315C11.9141 5.76 12.0296 6.06515 12.0304 6.42858C12.0312 6.792 11.9157 7.09715 11.6839 7.344C11.4521 7.59086 11.1666 7.71429 10.8273 7.71429L7.21822 7.71429L7.21822 11.5714C7.21822 11.9357 7.10273 12.2409 6.87175 12.4869C6.64076 12.7329 6.35525 12.8563 6.01519 12.8571C5.67513 12.858 5.38921 12.7346 5.15742 12.4869C4.92564 12.2391 4.81055 11.934 4.81215 11.5714L4.81215 7.71429L1.20304 7.71429C0.862182 7.71429 0.57626 7.59086 0.345277 7.344C0.114293 7.09715 -0.000796355 6.792 4.76125e-06 6.42858C0.000805877 6.06515 0.116298 5.75957 0.346479 5.51186C0.576659 5.26415 0.862182 5.14115 1.20304 5.14286L4.81215 5.14286L4.81215 1.28572C4.81215 0.921435 4.92764 0.615864 5.15863 0.369007C5.38961 0.122151 5.67513 -0.000850376 6.01519 6.05578e-06C6.35525 0.000862487 6.64077 0.123007 6.87175 0.369008Z"
                />
            </svg>
        </template>
        Create List
    </BrandButton>
</template>
